import { styled } from '@mui/material/styles';

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});

export const CoinButton = styled('button')(({ theme }) => ({
  width: '100%',

  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',

  border: '0',

  backgroundColor: 'transparent',

  color: theme.colors.base01,

  padding: '1.9rem 4rem',

  '&:hover': {
    backgroundColor: theme.colors.base04,
    cursor: 'pointer',
  },
}));

export const Divider = styled('div')(({ theme }) => ({
  width: 'calc(100% - 8rem)',

  display: 'flex',
  justifyContent: 'center',

  margin: 0,

  border: 0,
  borderTop: `0.1rem solid ${theme.colors.base06}`,
}));

export const LeftImageContainer = styled('div')({
  '& > img': {
    width: '3.6rem',
    height: '3.6rem',
  },
});

export const LeftContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',

  columnGap: '1.2rem',
});

export const LeftTextContainer = styled('div')({
  maxWidth: '17rem',

  wordBreak: 'keep-all',
  whiteSpace: 'nowrap',

  '& > *': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
});

export const RightContainer = styled('div')({
  minWidth: '19rem',

  display: 'flex',
  alignItems: 'center',

  columnGap: '2rem',
});

export const RightCommissionContainer = styled('div')({
  width: '100%',

  display: 'flex',

  justifyContent: 'space-between',
  alignItems: 'center',

  columnGap: '0.4rem',
});

export const Base02TextContainer = styled('div')(({ theme }) => ({
  color: theme.colors.base02,
}));
